// services/pricetags.js
import axiosInstance from './axiosInstance';

const PRICETAGS_API_URL = '/pricetags';

const pricetagsService = {
  async get(idempresa) {
    try {
      const response = await axiosInstance.get(`${PRICETAGS_API_URL}/get.php?idempresa=${idempresa}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter pricetags:', error);
      return [];
    }
  },

  async getById(idempresa, idpricetag) {
    try {
      const response = await axiosInstance.get(`${PRICETAGS_API_URL}/getById.php?idempresa=${idempresa}&idpricetag=${idpricetag}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter pricetag por ID:', error);
      return [];
    }
  },

  async set(pricetagData) {
    try {
      const response = await axiosInstance.post(`${PRICETAGS_API_URL}/set.php`, pricetagData);
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar pricetag:', error);
      throw error;
    }
  },

  async unset(idempresa, idpricetag) {
    try {
      const response = await axiosInstance.get(`${PRICETAGS_API_URL}/unset.php?idempresa=${idempresa}&idpricetag=${idpricetag}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao eliminar pricetag:', error);
      throw error;
    }
  }
};

export default pricetagsService;
